import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import axios from 'axios';

const SOMaterial = () => {
    const [formData, setFormData] = useState({
        dt: '',
        partyNm: '',
        adrs: '',
        contact: '',

    });
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    const [matlist, setMatlist] = useState([]);
    useEffect(() => {
        fetchMaterialData(Id);
    }, [Id]);

    const fetchMaterialData = async (id) => {

        try {
            const res = await axios.get(`${baseUrl}?apicall=getQuotationMaterialCalculationSOWISE&soId=${id}`);
            const data = res?.data;
            setMatlist(data?.data);
            // console.log(res?.data);
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {/* {formData?.firmId !== '' && <FirmHeaderImg firmId={formData?.firmId} />} */}
                        <h3 className='centered-heading'>Sale Order Material Info</h3>
                        <div className="dashed-line"></div>


                        <table style={{ margin: '1%', fontSize: '14px' }}>
                            <thead>
                                <th>Material Name</th>
                                <th>Size</th>
                                <th>Total Qty.</th>
                            </thead>
                            <tbody>
                                {
                                    matlist?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {item.materialNm} <br />
                                                <span style={{ color: 'red', fontSize: '15px' }} className='cursor-pointer'>
                                                    {`(Stock - ${item.mat_stock?.qty})`}
                                                </span>

                                            </td>
                                            <td>
                                                {item?.sizewise?.length > 0 ?
                                                    <tbody>
                                                        <tr>
                                                            <td>Size</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.size}</td>
                                                            ))}
                                                        </tr>

                                                        <tr>
                                                            <td>material size</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.matsize}</td>
                                                            ))}
                                                        </tr>

                                                        <tr>
                                                            <td>qty</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.totmqty}</td>
                                                            ))}
                                                        </tr>
                                                        <tr>
                                                            <td>type</td>
                                                            {item?.sizewise?.map((item, index) => (
                                                                <td>{item.mtype}</td>
                                                            ))}
                                                        </tr>

                                                    </tbody> : item?.sizewise
                                                }
                                            </td>

                                            <td>
                                                {item?.sizewise?.length > 0
                                                    ? item.sizewise.reduce(
                                                        (acc, sum) => acc + parseFloat(sum.totmqty || 0),
                                                        0
                                                    )
                                                    : item?.sizewise}
                                            </td>

                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default SOMaterial;
